<template>
    <van-search  :placeholder="placeholder" :use-left-icon-slot="true" :value="value" @input="value => $emit('input', value)"/>
</template>
<script>
import { Search } from 'vant';

export default {
    name: "EqSearch",
    components: {
        "van-search": Search,
    },
    props: {
        placeholder: {
            type: String,
            default: "请输入搜索关键词"
        },
        value: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            // value: undefined,
        };
    },
}
</script>